import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { UserSessionService } from '../../services';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  error = '';

  constructor(
    private _userSessionService: UserSessionService,
    private _router: Router
  ) { }

  ngOnInit() {
    this._userSessionService.logout().subscribe(() => {
      this._router.navigate(['login']);
    }, (error) => {
      if (error.Message !== undefined) {
        this.error = error.Message;
      } else {
        this.error = 'Es ist ein unbekannter Fehler aufgetreten';
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/logout/logout.component.ts